/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import './ProfilModal.css';
import { apiFetch } from './api';

function ProfilModal({ isOpen, onClose, user, userType }) {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [changingPassword, setChangingPassword] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      if (!isOpen || !user?.id) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const endpoint = userType === 'instructor' 
          ? `/instructor/profile`
          : `/student/profile`;
        
        const response = await apiFetch(endpoint);
        const data = await response.json();
        
        if (data.success) {
          setProfileData(data.profile);
        } else {
          setError(data.message || 'Profil bilgileri alınamadı');
        }
      } catch (err) {
        setError('Profil bilgileri yüklenirken bir hata oluştu');
        console.error('Profile fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen && user?.id) {
      fetchProfileData();
    }
  }, [isOpen, user?.id, userType]);

  if (!isOpen) return null;

  return (
    <div className="profil-modal-overlay" onClick={onClose}>
      <div className="profil-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="profil-modal-header">
          <h2 className="profil-modal-title">Profil Bilgileri</h2>
          <button className="profil-modal-close" onClick={onClose}>
            <span>×</span>
          </button>
        </div>

        {/* Content */}
        <div className="profil-modal-body">
          {loading && (
            <div className="profil-modal-loading">
              <p>Yükleniyor...</p>
            </div>
          )}

          {error && (
            <div className="profil-modal-error">
              <p>{error}</p>
            </div>
          )}

          {!loading && !error && profileData && (
            <>
              {/* Profil Bilgileri - alt alta iki kart */}
              <div className="profil-section">
                <div className="profil-section-content profil-section-content--stacked">
                  {userType === 'student' && (
                    <div className="profil-info-row profil-info-row--card">
                      <span className="profil-info-label">Öğrenci Numarası:</span>
                      <span className="profil-info-value">
                        {profileData.profil_bilgileri.student_number || user?.student_number || '-'}
                      </span>
                    </div>
                  )}
                  <div className="profil-info-row profil-info-row--card">
                    <span className="profil-info-label">Ad Soyad:</span>
                    <span className="profil-info-value">
                      {userType === 'student'
                        ? [profileData.profil_bilgileri.ad, profileData.profil_bilgileri.soyad].filter(Boolean).join(' ').trim() || '-'
                        : (profileData.profil_bilgileri.academician
                            || [profileData.profil_bilgileri.unvan, profileData.profil_bilgileri.ad, profileData.profil_bilgileri.soyad]
                                .filter(Boolean).join(' ').trim()
                            || '-')}
                    </span>
                  </div>
                  <div className="profil-info-row profil-info-row--card">
                    <span className="profil-info-label">E-posta:</span>
                    <span className="profil-info-value">
                      {userType === 'student' && !profileData.profil_bilgileri.email
                        ? (() => {
                            const num = profileData.profil_bilgileri.student_number || user?.student_number;
                            return num ? `${num}@kocaelisaglik.edu.tr` : '-';
                          })()
                        : (profileData.profil_bilgileri.email || '-')}
                    </span>
                  </div>
                </div>
              </div>

              {/* Akademik Bilgiler */}
              <div className="profil-section">
                <h3 className="profil-section-title">Akademik Bilgiler</h3>
                <div className="profil-section-content">
                  <div className="profil-info-row">
                    <span className="profil-info-label">Fakülte:</span>
                    <span className="profil-info-value">
                      {(() => {
                        const fakulte = profileData.akademik_bilgiler.fakulte || '';
                        // "Fakülte :" veya "Fakülte:" ile başlayan kısmı temizle (boşluklu veya boşluksuz)
                        return fakulte.replace(/^Fakülte\s*:\s*/i, '').trim() || '-';
                      })()}
                    </span>
                  </div>
                  <div className="profil-info-row">
                    <span className="profil-info-label">Program:</span>
                    <span className="profil-info-value">
                      {(() => {
                        const program = profileData.akademik_bilgiler.program || '';
                        // Eğer değer "Program:" ile başlıyorsa temizle
                        return program.replace(/^Program:\s*/i, '').trim() || '-';
                      })()}
                    </span>
                  </div>
                </div>
              </div>

            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfilModal;
